module.exports = __webpack_public_path__ + "media/alert2_2.cf67be71.wav";